import { useContext } from 'react';

import {
  type BaseInputContextProps,
  BaseInputContext,
} from '../contexts/BaseInputContext.js';

/**
 * @internal
 */
export const useBaseInputContext = (): BaseInputContextProps =>
  useContext(BaseInputContext);
